/** @fileoverview Shared native file selection and drop target with PrimeReact's `uploadHandler({ files, options.clear })` contract. Parents own admission, transport and saved attachment state; this control only rejects files over `maxFileSize` before delegating. */
import React, { useRef, useState } from 'react';

export function FileUpload({ name, multiple, accept, maxFileSize, uploadHandler, emptyTemplate, disabled, onValidationFail }) {
  const input = useRef(null);
  const [error, setError] = useState('');
  const select = files => {
    const selected = Array.from(files || []);
    const oversized = selected.find(file => maxFileSize && file.size > maxFileSize);
    if (oversized) { setError(`${oversized.name} exceeds the upload size limit.`); onValidationFail?.(oversized); return; }
    setError('');
    if (selected.length) uploadHandler?.({ files: selected, options: { clear: () => { if (input.current) input.current.value = ''; } } });
  };
  return <div onDragOver={event => event.preventDefault()} onDrop={event => { event.preventDefault(); if (!disabled) select(event.dataTransfer.files); }}>
    <input ref={input} type="file" name={name} multiple={multiple} accept={accept === '*' ? undefined : accept} disabled={disabled}
      aria-label="Choose files" onChange={event => select(event.target.files)} />
    {emptyTemplate}
    {error && <p role="alert">{error}</p>}
  </div>;
}
